<script lang="ts">
  import type { MediaConfig } from '@foundation-player/loader';
  import { createEventDispatcher, onMount } from 'svelte';

  export let mediaConfig: MediaConfig;
  export let index: number;

  let element: HTMLElement;

  const dispatch = createEventDispatcher<{ mount: HTMLElement }>();

  onMount(() => {
    dispatch('mount', element);
  });
</script>

<div
  data-index={index}
  bind:this={element}
  class="poster-image"
  style:--poster-image={mediaConfig.metadata?.poster ? `url(${mediaConfig.metadata.poster})` : undefined}
></div>

<style module>
  .poster-image {
    width: 100%;
    height: 100%;
    scroll-snap-align: start;
    background-size: cover;
    flex-shrink: 0;
    background-color: var(--poster-image-background-color, #666);
    background-image: var(--controls-gradient, none), var(--poster-image, none);
  }
</style>
